import { useContext, useMemo } from 'react';
import type { ComponentEnhancer } from 'recompose';

import withTranslations from './withTranslations';

import { isLocalAuthContext, LocalAuthContext } from '~/components/Auth';
import type { TMicroApps } from '~/components/Auth';

const withTranslationsInternal = <P extends {}>({
  appName,
  loader = <></>,
}: {
  appName: TMicroApps;
  loader?: React.ReactElement;
}) => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => {
    const auth = useContext(LocalAuthContext);

    let localeBaseUrl = isLocalAuthContext(auth) ? auth.company.localeUrls[appName] : undefined;

    const EnhancedComponent = useMemo(
      () => withTranslations<P>({ localeBaseUrl, loader })(Component),
      [localeBaseUrl]
    );

    return <EnhancedComponent {...props} />;
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withTranslationsInternal;
